import PricingStrategyFormLayout from './form'
import { PricingStrategyTitle } from './show'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm titleComponent={<PricingStrategyTitle />} formLayoutComponent={<PricingStrategyFormLayout />} />
)
